import {AbstractControl} from '@angular/forms';

export function maxValueValidator(max: number) {
    return (c: AbstractControl): { [key: string]: any } => {
        const isValid = (c.value == null || c.value.length === 0) || c.value <= max;
        if (!isValid) {
            return {'maxValue': {max}};
        } else {
            return null;
        }

    };
}

export function maxFieldSizeValidator(max: () => number) {
    return (c: AbstractControl): { [key: string]: any } => {
        const isValid = c.value == null || c.value.length <= max();
        if (!isValid) {
            return {maxlength: false};
        } else {
            return null;
        }
    };
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/validators/max-value.ts